export default __webpack_public_path__ + "static/media/mentor.1b1582cd.png";